<div class="backgroundColor backgroundColor star-dust darken-3">
  <section class="container-fluid backgroundColor star-dust darken-3 position-relative top-119" id="my-element">
    <div class="container">
      <div class="row pt-48 pb-16">
        <div class="col-12">
          <div class="col-6 mx-auto backgroundColor mine-shaft base p-5 text-white rounded-lg">
            <div class="d-flex justify-content-center mb-10">
              <img src="../../assets/images/logo/relojoariaFaria.svg" class="img-fluid" width="120px" alt="">
            </div>
            <div class="form-group">
              <label for="exampleInputEmail1">Nova Password</label>
              <input type="password" class="form-control" id="exampleInputpassword1" aria-describedby="passwordHelp" [(ngModel)]="pass">
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Confirme a nova Password</label>
              <input type="password" class="form-control" id="exampleInputPassword2" [(ngModel)]="cpass">
            </div>
            <button type="submit" class="btn btn-outline-secondary mt-10 text-white" (click)="send()">Submeter</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>